{
  "COMMUNITY_LESSON_NOT_FOUND": "Aula não encontrada",
  "GAMIFICATION_ACHIEVEMENT_NOT_FOUND": "Conquista não encontrada",
  "GAMIFICATION_ACHIEVEMENT_DELETED": "Conquista excluída com sucesso",
  "GAMIFICATION_LEVEL_ALREADY_EXISTS": "Este nível já existe",
  "GAMIFICATION_LEVEL_NOT_FOUND": "Nível não encontrado",
  "GAMIFICATION_LEVEL_DELETED": "Nível excluído com sucesso",
  "GAMIFICATION_BADGE_SHARE_LOGGED": "Compartilhamento do badge registrado com sucesso",
  "GAMIFICATION_WEEKLY_CHALLENGES_CREATED": "Desafios semanais criados com sucesso",
  "GAMIFICATION_MONTHLY_CHALLENGES_CREATED": "Desafios mensais criados com sucesso",
  "GAMIFICATION_WEEKLY_LEADERBOARD_RESET": "Ranking semanal reiniciado com sucesso",
  "GAMIFICATION_EXPIRED_REWARDS_CLEANED": "{{count}} recompensas expiradas foram removidas",
  "GAMIFICATION_BROKEN_STREAKS_CLEANED": "{{count}} sequências foram interrompidas",
  "GAMIFICATION_MONTHLY_FREEZES_RESET": "Freezes mensais de sequência reiniciados com sucesso",
  "STREAK_NOT_FOUND": "Nenhuma sequência encontrada",
  "STREAK_FREEZES_EXHAUSTED": "Você já usou todos os freezes disponíveis este mês",
  "STREAK_FREEZE_NOT_APPLICABLE": "Freeze só pode ser usado para prevenir quebra de sequência",
  "CHALLENGE_NOT_FOUND": "Desafio não encontrado",
  "CHALLENGE_DELETED": "Desafio excluído com sucesso",
  "CHALLENGE_NOT_ACTIVE": "Desafio não está ativo",
  "CHALLENGE_NOT_STARTED": "Desafio ainda não começou",
  "CHALLENGE_ENDED": "Desafio já terminou",
  "CHALLENGE_FULL": "Desafio já atingiu o máximo de participantes",
  "CHALLENGE_ALREADY_JOINED": "Você já está participando deste desafio",
  "CHALLENGE_TEAM_REQUIRED": "Este desafio requer que você faça parte de uma equipe",
  "CHALLENGE_TEAM_INVALID": "Equipe inválida para este desafio",
  "CHALLENGE_TEAM_NOT_ACCEPTING_MEMBERS": "Esta equipe não está aceitando novos membros",
  "CHALLENGE_TEAM_FULL": "Esta equipe já está cheia",
  "CHALLENGE_PARTICIPATION_NOT_FOUND": "Participação no desafio não encontrada",
  "CHALLENGE_NOT_TEAM_BASED": "Este desafio não é baseado em equipes",
  "CHALLENGE_TEAM_NOT_FOUND": "Equipe não encontrada",
  "CHALLENGE_ALREADY_IN_TEAM": "Você já faz parte de uma equipe neste desafio",
  "CHALLENGE_TEAM_JOINED": "Você foi adicionado à equipe com sucesso",
  "REWARD_NOT_FOUND": "Recompensa não encontrada",
  "REWARD_DELETED": "Recompensa excluída com sucesso",
  "REWARD_UNAVAILABLE": "Esta recompensa não está mais disponível",
  "REWARD_EXPIRED": "Esta recompensa expirou",
  "REWARD_OUT_OF_STOCK": "Esta recompensa está fora de estoque",
  "REWARD_INSUFFICIENT_XP": "Você precisa de {{required}} XP para resgatar esta recompensa. Você tem {{current}} XP.",
  "REWARD_REDEEMED_RECENTLY": "Você já resgatou esta recompensa recentemente. Tente novamente amanhã.",
  "REWARD_REDEEMED": "Recompensa resgatada com sucesso!",
  "REWARD_REDEMPTION_NOT_FOUND": "Resgate não encontrado",
  "COMMENT_NOT_FOUND": "Comentário não encontrado",
  "COMMENT_LESSON_COMMENTS_DISABLED": "Esta aula não permite comentários",
  "COMMENT_PARENT_NOT_FOUND": "Comentário pai não encontrado",
  "COMMENT_PARENT_LESSON_MISMATCH": "Comentário pai pertence a outra aula",
  "COMMENT_EDIT_FORBIDDEN": "Você não pode editar este comentário",
  "COMMENT_DELETE_FORBIDDEN": "Você não pode deletar este comentário",
  "COMMENT_PIN_FORBIDDEN": "Você não tem permissão para fixar comentários",
  "COMMENT_DELETED": "Comentário deletado com sucesso",
  "COMMENT_CONTENT_TOO_SHORT": "O comentário deve ter no mínimo 3 caracteres",
  "REACTION_ADDED": "Reação adicionada",
  "REACTION_REMOVED": "Reação removida",
  "NOTIFICATION_NOT_FOUND": "Notificação não encontrada",
  "NOTIFICATION_ALL_MARKED_READ": "Todas as notificações foram marcadas como lidas",
  "NOTIFICATION_DELETED": "Notificação deletada",
  "SURVEY_NOT_FOUND": "Pesquisa não encontrada",
  "SURVEY_NOT_ACTIVE": "Pesquisa não está ativa",
  "SURVEY_RESPONSE_LIMIT_REACHED": "Pesquisa atingiu o limite de respostas",
  "SURVEY_ALREADY_ANSWERED": "Você já respondeu esta pesquisa",
  "SURVEY_QUESTION_REQUIRED": "A pergunta \"{{question}}\" é obrigatória",
  "QUIZ_NOT_FOUND": "Quiz não encontrado",
  "QUIZ_ALREADY_TAKEN": "Você já fez esta avaliação",
  "QUIZ_MAX_RETRIES_EXCEEDED": "Máximo de {{max}} tentativas excedido",
  "QUIZ_ATTEMPT_NOT_FOUND": "Tentativa não encontrada",
  "QUIZ_ATTEMPT_FORBIDDEN": "Tentativa não pertence ao usuário",
  "QUIZ_ATTEMPT_ALREADY_FINISHED": "Tentativa já finalizada",
  "CUSTOM_FIELD_NOT_FOUND": "Campo não encontrado",
  "COMMUNITY_NOT_CONFIGURED": "Integração com a comunidade não configurada",
  "COMMUNITY_USER_NOT_FOUND": "Usuário não encontrado.",
  "COMMUNITY_AUTH_FAILED": "Não foi possível autenticar na comunidade.",
  "COMMUNITY_SPACES_FETCH_FAILED": "Não foi possível listar os espaços da comunidade.",
  "CIRCLE_CONFIG_SAVED": "Configuração do Circle salva com sucesso",
  "CIRCLE_TOKEN_NOT_CONFIGURED": "Token da API do Circle não configurado",
  "CIRCLE_API_ERROR": "A API do Circle retornou um erro ({{status}})",
  "CIRCLE_STATS_FETCH_FAILED": "Não foi possível obter as estatísticas do Circle"
}
